export enum LocalStorageKey {
    productChecklistFilters = 'productChecklistFilters',
}
